var _defs, _use;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServices(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M.693 19.108l7.138-6.841 3.368 3.228-7.138 6.841c-.925.886-2.422.888-3.36-.01-.928-.891-.94-2.327-.008-3.218zM1.6 20.7c0-.423.358-.767.8-.767.442 0 .8.344.8.767 0 .423-.358.767-.8.767-.442 0-.8-.344-.8-.767zM.817 1.554c-.05-.551.407-.894.866-.894.294 0 .588.14.754.456.029.055.157.205.42.378.394.26.934.448 1.66.515 2.692.251 4.286 2.315 2.947 4.186-1.367 1.912-3.862 2.182-5.21-.053a8.645 8.645 0 01-.6-1.212c-.302-.74-.522-1.528-.675-2.312a11.074 11.074 0 01-.162-1.064zm8.22 4.772a.88.88 0 011.206.005.798.798 0 01.005 1.156L7.812 9.821a.877.877 0 01-1.206-.005A.798.798 0 016.6 8.66l2.436-2.334zm-.833 4.754l3.357-3.217 11.516 11.036a2.21 2.21 0 01.005 3.221c-.925.886-2.432.886-3.362-.005L8.204 11.08zm7.224-6.973c0-2.269 1.92-4.107 4.286-4.107.555 0 1.084.101 1.57.284l-1.898 1.82a1.586 1.586 0 00-.003 2.327c.675.646 1.757.64 2.428-.004l1.895-1.816c.19.463.294.969.294 1.496 0 2.269-1.92 4.107-4.286 4.107a4.42 4.42 0 01-.83-.077l-2.631 2.522-3.358-3.217 2.62-2.51a3.959 3.959 0 01-.087-.825z",
    id: "a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#7C98B6",
    xlinkHref: "#a",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/Services.6e1cf421d6c744de89ca9c1883dd36eb.svg";
export { ForwardRef as ReactComponent };